import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationTextarea from "../components/PersonalizationTextarea";

export default function WellnessThankYouScreen({getWellnessError, wellnessFormData,setWellnessFormData}) {

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_thank_you.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Title'}
            value={wellnessFormData?.thankYouTitle?.toUpperCase()}
            setValue={(value) => setWellnessFormData({thankYouTitle:value?.toUpperCase()})}
            errorMessage={getWellnessError('wellnessSettings', 'thankYouTitle')}
        />


        <PersonalizationInput
            title={'Section Title'}
            value={wellnessFormData?.thankYouSectionTitle}
            setValue={(value) => setWellnessFormData({thankYouSectionTitle:value})}
            errorMessage={getWellnessError('wellnessSettings', 'thankYouSectionTitle')}
        />


        <PersonalizationTextarea
            title={'Description'}
            value={wellnessFormData?.thankYouDescription}
            setValue={(value) => setWellnessFormData({thankYouDescription:value})}
            errorMessage={getWellnessError('wellnessSettings', 'thankYouDescription')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={wellnessFormData?.thankYouVideoLink}
            setValue={(value) => setWellnessFormData({thankYouVideoLink:value})}
            errorMessage={getWellnessError('wellnessSettings', 'thankYouVideoLink')}
        />
    </div>
}
